
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import CustomSelectDropdown from '../../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import ActionButton from '../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_available_equipment_with_pagination } from '../../../../../config/Resource/equipmentApis';


function AddSchEquipmementModal({ IsUrgentSchedule, handleSave, isButtonDisabled, scheduleInfo, scheduleID, isDisabled }) {
    const [availableEquipments, setAvailableEquipments] = useState([]);

    // FETCH fetchScheduleEquipments
    const fetchScheduleEquipments = async () => {
        try {
         
            const params = {
                TechnologyId: scheduleInfo.SD_TechnologyId,
                Survey_from_date: scheduleInfo.SD_Survey_from_date,
                Survey_end_date: scheduleInfo.SD_Survey_end_date,
                schedule_id: scheduleID ? scheduleID : '',
                is_urgent: IsUrgentSchedule ? 1 : 0
            };
            const response = await get_available_equipment_with_pagination(params);

            if (response?.status === "success") {
                const transformedData = response?.data?.map((item) => ({
                    label: `${item?.EquipmentName} (${item?.EquipmentserialNo || ''})`,
                    value: item?.EquipmentId,
                })) || [];

                // Set the transformed data to the state
                setAvailableEquipments(transformedData || []);
            } else {
                setAvailableEquipments([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setAvailableEquipments([]);
        }
    };

    const formik = useFormik({
        initialValues: {
            equipmentIDs: [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            equipmentIDs: Yup.array().min(1, 'At least one Equipment is required'),
        }),
        onSubmit: (values) => {
            handleSave(values, 'Add');

        },
    });

    const handleReset = () => {
        formik.setValues({
            equipmentIDs: [],
        });
        formik.setTouched({
            equipmentIDs: false,
        });
    };

    useEffect(() => {
        if (scheduleID) {
            fetchScheduleEquipments()
        }

    }, [scheduleID])
    return (
        <div className='update-status-form-container'>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <div className='update-status-form-mid-container'>
                        <div className='update-status-label-container'>
                            <span className='update-status-label'>
                                Equipments <span className='update-status-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='update-status-custom-textfield-container'>
                            <CustomSelectDropdown
                                name="equipmentIDs"
                                placeholder="Select Equipments"
                                options={availableEquipments}
                                value={availableEquipments?.filter(option => formik.values.equipmentIDs?.includes(option.value))}
                                onChange={(selectedOptions) => {
                                    // Map selected options to extract only the `value` (ID) field
                                    const selectedValues = selectedOptions.map(option => option.value);
                                    // Set the field value with the array of selected IDs
                                    formik.setFieldValue("equipmentIDs", selectedValues);
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.equipmentIDs && Boolean(formik.errors.equipmentIDs)}
                                helperText={formik.touched.equipmentIDs && formik.errors.equipmentIDs}
                                isDisabled={isDisabled}

                                isMulti={true} // Set to true for multi-select
                                width="100%"
                            />

                        </div>
                    </div>
                </Grid>
            </Grid>

            <div className='update-status-form-bottom-action-buttons-container'>
                <ActionButton onClick={handleReset} label='Reset' btnType='outlined' />
                <ActionButton onClick={formik.handleSubmit} btnDisable={isButtonDisabled} label='Save' btnType='primary' />
            </div>
        </div>
    );
}

export default AddSchEquipmementModal;
